// Copyright (c) 2016 Deere & Company

import Criteria, {getDefaultState} from '../../maintenance-plan/state/criteria';
import {updateKeyValueSelectionList, updateList} from '../../../shared/services/list-selections';
import actions from '../../actions-list';

const resetSearchCriteria = () => getDefaultState();

const updateSelectedDealers = (state, action) =>
    Criteria.update(state, {
        selectedDealers: {
            $set: updateList(
                action.dealer,
                action.isSelected,
                'account',
                state.selectedDealers
            )
        }
    });

const updateSelectAllDealers = (state, action) => {

    const toggleSelectedDealersState = state.selectedDealers.length > 0 ? [] : action.dealers;

    return Criteria.update(state, {
        selectedDealers: {
            $set: toggleSelectedDealersState
        }
    });

};

const updateSelectedDealersOnLoad = (state, action) =>
    Criteria.update(state, {
        selectedDealers: {
            $set: action.dealers
        }
    });

const updateMaintenancePlanAttributesCriteria = (state, action) =>
    Criteria.update(state, {
        [action.attribute]: {
            $set: action.value
        }
    });

const updatePlanStartDate = (state, action) =>
    Criteria.update(state, {
        planStartDate: {
            from: {
                $set: action.planStartDateRange.from
            },
            to: {
                $set: action.planStartDateRange.to
            }
        }
    });

const updatePlanEndDate = (state, action) =>
    Criteria.update(state, {
        planEndDate: {
            from: {
                $set: action.planEndDateRange.from
            },
            to: {
                $set: action.planEndDateRange.to
            }
        }
    });

const updateServiceIntervalBeginDate = (state, action) =>
    Criteria.update(state, {
        serviceIntervalBeginDate: {
            from: {
                $set: action.serviceIntervalBeginDateRange.from
            },
            to: {
                $set: action.serviceIntervalBeginDateRange.to
            }
        }
    });

const updateServiceIntervalEndDate = (state, action) =>
    Criteria.update(state, {
        serviceIntervalEndDate: {
            from: {
                $set: action.serviceIntervalEndDateRange.from
            },
            to: {
                $set: action.serviceIntervalEndDateRange.to
            }
        }
    });

const updateServiceIntervalStatuses = (state, action) =>
    Criteria.update(state, {
        serviceIntervalStatuses: {
            allowed: {
                $set: action.data
            }
        }
    });

const updateSelectedServiceIntervalStatus = (state, action) =>
    Criteria.update(state, {
        serviceIntervalStatuses: {
            selected: {
                $set: updateKeyValueSelectionList(
                    action.status,
                    action.isSelected,
                    state.serviceIntervalStatuses.selected
                )
            }
        }
    });

const updateSelectAllServiceIntervalStatuses = state => {

    const toggleSelectedStatusesState = state.serviceIntervalStatuses.selected.length > 0 ? [] : state.serviceIntervalStatuses.allowed;

    return Criteria.update(state, {
        serviceIntervalStatuses: {
            selected: {
                $set: toggleSelectedStatusesState
            }
        }
    });

};

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_MAINTENANCE_PLAN_REPORT_SEARCH_CRITERIA]: resetSearchCriteria,
        [actions.UPDATE_MAINTENANCE_PLAN_ATTRIBUTES_CRITERIA]: updateMaintenancePlanAttributesCriteria,
        [actions.UPDATE_MAINTENANCE_PLAN_DEALER_CRITERIA]: updateSelectedDealers,
        [actions.UPDATE_MAINTENANCE_PLAN_PLAN_END_DATE_CRITERIA]: updatePlanEndDate,
        [actions.UPDATE_MAINTENANCE_PLAN_PLAN_START_DATE_CRITERIA]: updatePlanStartDate,
        [actions.UPDATE_MAINTENANCE_PLAN_SELECT_ALL_DEALERS_CRITERIA]: updateSelectAllDealers,
        [actions.UPDATE_MAINTENANCE_PLAN_SELECT_ALL_DEALERS_CRITERIA_ON_LOAD]: updateSelectedDealersOnLoad,
        [actions.UPDATE_MAINTENANCE_PLAN_SELECT_ALL_SERVICE_INTERVAL_STATUSES_CRITERIA]: updateSelectAllServiceIntervalStatuses,
        [actions.UPDATE_MAINTENANCE_PLAN_SERVICE_INTERVAL_BEGIN_DATE_CRITERIA]: updateServiceIntervalBeginDate,
        [actions.UPDATE_MAINTENANCE_PLAN_SERVICE_INTERVAL_END_DATE_CRITERIA]: updateServiceIntervalEndDate,
        [actions.UPDATE_MAINTENANCE_PLAN_SERVICE_INTERVAL_STATUSES_CRITERIA]: updateSelectedServiceIntervalStatus,
        [actions.UPDATE_MAINTENANCE_PLAN_SERVICE_INTERVAL_STATUSES_SUCCESS]: updateServiceIntervalStatuses
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/reducers/criteria.js